<form class="grid grid-nogutter p-fluid text-center" [formGroup]="form" (submit)="submitForm()">
    <h3 class="col-12 mt-2 mb-6">
        Üdvözöljök a Debreceni Egyetem időpontfoglaló rendszerében! A folytatáshoz jelentkezzen be!
    </h3>
    <div class="grid col-8 md:col-4 col-offset-2 md:col-offset-4 card text-left align-items-center">
        <input type="email" style="position:absolute; opacity:0; height:0; border:0;">
        <input type="password" style="position:absolute; opacity:0; height:0; border:0;">
        <label class="font-semibold col-12 md:col-4 pb-0">Egyetemi azonosító
            @if (form.get('email')?.invalid && (form.get('email')?.dirty)) {
                <i class="pi pi-exclamation-triangle" [ngStyle]="{float: 'right', fontSize: '1.5rem', color: '#C62828'}"
                    [pTooltip]="'A mező kitöltése kötelező!'"></i>
            }</label>
        <div class="col-12 md:col-8 flex-auto">
            <input pInputText autocomplete="off" [fluid]="true" type="text"
                   formControlName="user"/>
        </div>
        <label class="font-semibold col-12 md:col-4 pb-0">Jelszó
            @if (form.get('password')?.invalid && (form.get('password')?.dirty)) {
                <i class="pi pi-exclamation-triangle" [ngStyle]="{float: 'right', fontSize: '1.5rem', color: '#C62828'}"
                   [pTooltip]="'A mező kitöltése kötelező!'"></i>
            }
        </label>
        <div class="col-12 md:col-8 flex-auto">
            <input pInputText autocomplete="off" [fluid]="true" [type]="'password'"
                   formControlName="password"/>
        </div>
        <div class="col-12 md:col-6 md:col-offset-3">
            <button pButton label="Bejelentkezés"
                    type="submit" [ngStyle]="{mindWidth: '100px'}"></button>
        </div>
    </div>
</form>

<p-toast #toast position="center" key="center">
    <ng-template let-message #message>
        <div class="grid text-center">
            <div class="col-12 font-medium text-2xl mb-3">{{ message.summary }}</div>
            <div class="col-12 font-medium text-lg">{{ message.detail }}</div>
            <div class="col-12 font-medium">
                <span class="inline-block align-content-center" [ngStyle]="{padding: '1rem', borderRadius: '50%',
                background: message.severity === 'success' ? '#43A047' : '#E53935', color: 'white'}">
                    <i class="pi" [ngStyle]="{fontSize: '2rem'}"
                       [ngClass]="message.severity === 'success' ? 'pi-envelope' : 'pi-exclamation-triangle'"></i>
                </span></div>
            <div class="col-12">
                <button pButton
                        [label]="'OK'" type="button" (click)="clearToasts()"
                        [ngClass]="message.severity === 'success' ? 'p-button-success' : 'p-button-danger' "></button>
            </div>
        </div>
    </ng-template>
</p-toast>
